module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.component) ? _c(_vm.component, {
    tag: "component",
    attrs: {
      "note": _vm.note,
      "locked": _vm.locked,
      "pageWidth": _vm.pageWidth,
      "pageHeight": _vm.pageHeight,
      "totalPages": _vm.totalPages,
      "selectedElement": _vm.selectedElement,
      "currentNoteLayerBackground": _vm.currentNoteLayerBackground
    },
    on: {
      "updatePageHistory": _vm.updatePageHistory,
      "updateNote": _vm.updateNote,
      "activated": _vm.onActivated,
      "setSelectedElement": _vm.copySelectedElement,
      "copyElement": _vm.copyElement,
      "deactivated": _vm.onDeactivated
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50c24042","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/notes/wrapper.vue
// module id = 1242
// module chunks = 21